import App from "./app/App";
import BrowserLoginPage from "./app/auth/BrowserLoginPage";
import OperatorApp from "./operator-app/App";
import { BrowserRouter, Route, Routes, useNavigate, useLocation } from "react-router-dom";
import WebApp from "@twa-dev/sdk";
import { useLayoutEffect, useRef } from "react";

function decodeStartParamPath(startParam) {
  const padded = startParam.padEnd(
    startParam.length + (4 - startParam.length % 4) % 4,
    "="
  );
  return atob(padded.replace(/-/g, "+").replace(/_/g, "/"));
}

/** Must render under BrowserRouter: replaceState does not update React Router's location. */
function TelegramStartParamNavigate() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  // Keep forcing start_param until we actually land on it (auth/index can
  // redirect to the dashboard in between). After landing, stop so Back works.
  const hasLandedOnStartPath = useRef(false);

  useLayoutEffect(() => {
    const startParam = WebApp.initDataUnsafe?.start_param;
    if (!startParam) {
      return;
    }

    try {
      const path = decodeStartParamPath(startParam);

      if (pathname === path) {
        hasLandedOnStartPath.current = true;
        return;
      }

      if (hasLandedOnStartPath.current) {
        return;
      }

      navigate(path, { replace: true });
    } catch (error) {
      console.error("Invalid startapp payload:", error);
    }
  }, [navigate, pathname]);

  return null;
}

function RootRouter() {
  return (
    <BrowserRouter>
      <TelegramStartParamNavigate />
      <Routes>
        <Route path="/login" element={<BrowserLoginPage />} />
        <Route path="/operator/*" element={<OperatorApp />} />
        <Route path="*" element={<App />} />
      </Routes>
    </BrowserRouter>
  );
}

export default RootRouter;
